var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayStoreLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5129_785)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.53711 1.61709V20.1038C1.53724 20.144 1.54921 20.1831 1.57152 20.2165C1.59383 20.2498 1.62546 20.2758 1.66251 20.2912C1.69952 20.3067 1.74029 20.3108 1.77962 20.3032C1.819 20.2956 1.85525 20.2764 1.88383 20.2482L11.5096 10.8609L1.88383 1.4727C1.85525 1.44456 1.819 1.42543 1.77962 1.41781C1.74029 1.41015 1.69952 1.41427 1.66251 1.42973C1.62546 1.44514 1.59383 1.47117 1.57152 1.50451C1.54921 1.53784 1.53724 1.57695 1.53711 1.61709Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5467 7.00012L3.47715 0.35054L3.46962 0.346329C3.26174 0.233428 3.06417 0.514694 3.23446 0.6784L12.6956 9.72515L15.5467 7.00012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.23501 21.0399C3.06378 21.2036 3.26135 21.4849 3.47022 21.372L3.47774 21.3677L15.5463 14.7182L12.6952 11.9922L3.23501 21.0399Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4199 9.68422L17.0497 7.82812L13.8809 10.8601L17.0497 13.8907L20.4199 12.0361C21.3367 11.5295 21.3367 10.1908 20.4199 9.68422Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5129_785"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.5049,
    height: 21.5049,
    fill: "white",
    transform: "translate(0.566406 0.105469)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStoreLogo);
export default __webpack_public_path__ + "static/media/play-store-logo.e07bce81d783c489972fedc1ade58def.svg";
export { ForwardRef as ReactComponent };